const INVALID_NAME_CHARACTERS_REGEX = /[^a-zA-Z, \.\-']/g; //eslint-disable-line no-useless-escape
const AT_LEAST_3_LETTERS_REGEX = /(?:.*[a-zA-Z]){3}/g;

export const validateName = name => {
  const meetsLengthRequirements = name.length >= 3 && name.length <= 50;
  const containsInvalidCharacters = !!name.match(INVALID_NAME_CHARACTERS_REGEX);
  const containsAtLeast3Letters = !!name.match(AT_LEAST_3_LETTERS_REGEX);
  
  return meetsLengthRequirements && !containsInvalidCharacters && containsAtLeast3Letters;
}